import { IHouse } from '../../../types/newbuilding/house';

export function sortByOffers(prev: IHouse, next: IHouse) {
  return (next.fromDeveloperPropsCount as number) - (prev.fromDeveloperPropsCount as number);
}
